import React from 'react'

export default function Timeline() {
    return (
        <div>
            <div className="timeline">
                <div className="container left">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2019</h2>
                        </div>
                        <p className='timeline-company'>Flatiron School</p>
                        <p className='timeline-role'>Immersive Fullstack Web Development</p>
                    </div>
                </div>
                <div className="container right">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2019</h2>
                        </div>
                        <p className='timeline-company'>Harvard Business School Online</p>
                        <p className='timeline-role'>Certificate in Business Analytics</p>                    
                    </div>
                </div>
                <div className="container left">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2018-2019</h2>
                        </div>
                        <p className='timeline-company'>Humanitas360</p>
                        <p className='timeline-role'>Consultant</p>
                    </div>
                </div>
                <div className="container right">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2018</h2>
                        </div>
                        <p className='timeline-company'>Mile High United Way</p>
                        <p className='timeline-role'>Marketing Intern</p>
                    </div>
                </div>
                <div className="container left">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2018</h2>
                        </div>
                        <p className='timeline-company'>Enterprise Rent-A-Car</p>
                        <p className='timeline-role'>Consultant</p>
                        
                    </div>
                </div>
                <div className="container right">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2017-2019</h2>
                        </div>
                        <p className='timeline-company'>University of Denver</p>
                        <p className='timeline-role'>Masters of Business Administration</p>
                    </div>
                </div>
                <div className="container left">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2014-2015</h2>
                        </div>
                        <p className='timeline-company'>Fordham University</p>
                        <p className='timeline-role'>B.A., Business</p>
                    </div>
                </div>
                <div className="container right">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2012-2016</h2>
                        </div>
                        <p className='timeline-company'>Bartaco</p>
                        <p className='timeline-role'>General Manager | Corporate Trainer</p>
                    </div>
                </div>
                <div className="container left">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2011</h2>
                        </div>
                        <p className='timeline-company'>Deer Valley Resort</p>
                        <p className='timeline-role'>Head Soup Chef</p>
                    </div>
                </div>
                <div className="container right">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2011-2012</h2>
                        </div>
                        <p className='timeline-company'>Plates Restaurant</p>
                        <p className='timeline-role'>Head Catering Chef</p>
                    </div>
                </div>
                <div className="container left">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2010-2012</h2>
                        </div>
                        <p className='timeline-company'>Picnic Catering Co.</p>
                        <p className='timeline-role'>Business Owner | Private Chef</p>
                    </div>
                </div>
                <div className="container right">
                    <div className="content">
                        <div className='timeline-year-header'>
                            <h2 className='timeline-year'>2010-2012</h2>
                        </div>
                        <p className='timeline-company'>Culinary Institute of America</p>
                        <p className='timeline-role'>Associates Degree, Culinary Arts</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
